import React, { Component, Fragment } from 'react'

import { TextField, MenuItem, FormControlLabel, FormLabel, Radio, RadioGroup, Grid, InputAdornment } from '@mui/material';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';

import { getTrainingProviderOptions, getTrainingProviderData, createTrainingProvider, updateTrainingProvider } from '../helper/APIcalls'
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import { GridAutoTextField, GridTextValidator } from '../helper/GridComponents'
import { authContext } from "../../context/AuthContext";
import axios from 'axios';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import LocationBox from '../helper/LocationBox';

import ContactBox from '../helper/ContactBox';

import { languages } from '../../constants/global';

import { GridAutoTextValidator } from '../helper/GridComponents';


class TrainingProvWorkshop extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);

        // if (!ValidatorForm.hasValidationRule('isLess25')) {
        //     ValidatorForm.addValidationRule('isLess25', (value) => {
        //         if (this.isAdmin) return true // if admin, then there is no need to check
        //         else if (value <= 25) return true // if the value is over 25

        //         return false
        //     });
        // }

        this.state = {
            loading: true,

            // API fields
            categories: [],
            organizations: [],
            organizationsFiltered: [],
            instructors: [],
            leadInstructors: [],
            locTemplates: [],
            contactTemplates: [],
            programs: [],

            groupName: '',
            groupType: 'Training Provider',
            groupCity: '',
            groupAddress: '',
            groupState: '',
            groupZipcode: '',
            locID: '', //used for updating the location
            groupStates: [],

            //formVisible: false,

            lang: null,
            cost: '',
            minParticipants: '',
            maxParticipants: '',

            // autocomplete fields
            categoryID: null,
            leadInstructorId: null,
            organizationId: null,
            location_id: '',
            isPublic: true,
            workshopProgram: null,
            contact_id: '',

            modulePresenters: [],

            groupNameChecked: false,

            counties:[],
            states: [],

            locTemplate: '',
            locationName: '',
            locationStreet: '',
            locationCity: '',
            locationCounty: null,
            locationZipcode: '',
            locationStateCode: null,
            locationMapURL: '',


            contact: { FIRSTNAME: null, PHONE: null },
            contactTemplate: '',
            contactFirstname: '',
            contactLastname: '',
            contactPhone: '',
            contactEmail: '',
            modules: [],
            workshopProgramTitle: { title: '' },
            location: { NAME: null, STREET: null, CITY: null },
        }

    }

    async componentDidMount() {
        const ID = this.props.ID
        try {
            let program = null //handle set program

            // let program_workshop = null// handles the program changing for module presenters
            // let category = null

            const options = await getTrainingProviderOptions()
            this.setState(options)
            axios.get('/api/stateCounty/states', {
            }).then((res) => {
                let states = res.data.states;
                this.setState({ groupStates: states });
            }).catch(error => {
                console.log("There is an error in loading the list of the states")

            });
            if (ID) {
                const data = await getTrainingProviderData(ID, options)
                program = data.workshopProgram
                this.setState(data)

                const res = await axios.get('/api/stateCounty/county/' + data.groupState)
                const counties = res.data.map(u =>({ label: u.stateCountyName, value: u.stateCountyName }))
                this.setState({counties,})


            }

            // if there is only one program available, and the program is currently null, set the program to that one
            if (options.programs.length === 1 && program === null) {
                program = options.programs[0]
                this.setState({ workshopProgram: program })
            }

            if (this.props.ID ) {

                const data = await getTrainingProviderData(this.props.ID, options)
                console.log("data: " + JSON.stringify(data));
                const fields = {
                    category: data.categoryID,
                    lang: (data.lang !== null) ? languages.find((lang) => lang.value === data.lang) : null,
                    maxParticipants: data.maxParticipants,
                    minParticipants: data.minParticipants,
                    cost: data.cost,

                   // locationMapURL: data.mapURL,
                    isPublic: data.isPublic,

                    locTemplate: data.location_id,
                    location_id: data.location_id,
                    leadInstructor: data.leadInstructorId,

                    contact_id: data.contact_id,
                    contactTemplate : data.contact_id,

                    organization: data.organizationId,
                    program: data.workshopProgram,
                }

                // also load in the contact template extra info
                this.onContactTemplateChange(null, data.contact_id)

                //also load in locTemplate info
                this.onLocTemplateChange(null, data.location_id)

                // category = fields.category

                this.setState(fields)
                program = fields.program
                this.setFilteredOrgs(fields.category)

            }
            
            this.setState({ loading: false })

        } catch (err) {
            console.log('error', err)
            this.props.setError(err)
        }

    }

    // componentWillUnmount = () => {
    //     if (ValidatorForm.hasValidationRule('isLess25')) {
    //         ValidatorForm.removeValidationRule('isLess25');
    //     }
    // }

    onLocTemplateChange = (name, value) => {
        let selected = value;
        console.log("onLocTemplateChange: " +selected);

        if (selected === null || selected === undefined) {
            this.setState({
                // locTemplate: '',
                locationName: '',
                locationStreet: '',
                locationCity: '',
                locationCounty: null,
                locationStateCode: null,
                locationZipcode: '',
                locationMapURL: ''
            });
            return;
        } 
        axios.get('/api/locationTemplate/' + selected.value, {
        }).then((res) => {
            // get counties call so that the county list has the right entries
            axios.get('/api/stateCounty/county/' + res.data.locTemplate.stateCode).then((res2)=>{
                const county = res2.data.map(u =>({ label: u.stateCountyName, value: u.stateCountyName }))
                this.setState({
                    // locTemplate: this.locTemplates.find(el => el.value === selected.value),
                    locationName: res.data.locTemplate.name,
                    locationStreet: res.data.locTemplate.street,
                    locationCity: res.data.locTemplate.city,
                    locationZipcode: res.data.locTemplate.zipCode,
                    locationMapURL: res.data.locTemplate.mapURL,
                    locationCounty: { label: res.data.locTemplate.countyCode, value: res.data.locTemplate.countyCode } ,
                    locationStateCode: { label: res.data.locTemplate.stateCode, value: res.data.locTemplate.stateCode },
                    location_id: selected,
                    counties: county,
                });
            })
            
        });
    }

    onContactTemplateChange = (name, value) => {
        let selected = value;
        if (selected === null) {
            this.setState({
                // contactTemplate: '',
                contactFirstname: '',
                contactLastname: '',
                contactPhone: '',
                contactEmail: ''
            });
            return;
        }

        axios.get('/api/contactTemplate/' + selected.value, {
        }).then((res) => {
            this.setState({
                // contactTemplate: this.contactTemplates.find(el => el.value === selected.value),
                contactFirstname: res.data.template.firstName,
                contactLastname: res.data.template.lastName,
                contactPhone: res.data.template.phone,
                contactEmail: res.data.template.email,
                contact_id: selected
            });
        });
    }

    onAddLocationTemplate = event => {
        let token = sessionStorage.getItem('accessToken');
        let url = "/api/locationTemplate";
        let data = {
            name: this.state.locationName,
            countyCode: this.state.locationCounty.value,
            city: this.state.locationCity,
            street: this.state.locationStreet,
            stateCode: this.state.locationStateCode.value,
            zipCode: this.state.locationZipcode,
            mapURL: this.state.locationMapURL,
            byUsername: this.context.user.username
        }
        axios(url, 
             {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }, data})
        .then(response => {
            if (response.status === 200) {
                let loc = {label: response.data.loc.name, value: response.data.loc.ID}
                let locTemplates = [];

                axios.get('/api/locationTemplate/').then((res) => {
                    res.data.locTemplates.forEach((u) => {
                        locTemplates.push({ label: u.name, value: u.ID });
                    });            
                    this.setState({
                        locTemplates: locTemplates,
                        locTemplate: loc,
                        location_id: loc
                    });
                });
            }
        });

    }

    onAddContactTemplate = event => {
        var url = "/api/contactTemplate";
        let token = sessionStorage.getItem('accessToken');

        var data = {
            firstName: this.state.contactFirstname,
            lastName: this.state.contactLastname,
            email: this.state.contactEmail,
            phone: this.state.contactPhone,
            byUsername: this.context.user.username
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data})
        .then(response => {
            if (response.status === 200) {
                let contactTemplates = [];
                let contact = {label: response.data.contact.lastName + ', ' + response.data.contact.firstName , value: response.data.contact.ID}

                axios.get('/api/contactTemplate/').then((res) => {
                    res.data.templates.forEach((u) => {
                        contactTemplates.push({ label: u.lastName + ', ' + u.firstName, value: u.ID });
                    });            
                    this.setState({
                        contactTemplates: contactTemplates,
                        contact_id: contact,
                        contactTemplate: contact
                    });
                });
            }
        });
    }

    getDataFromStateFields = () => {
        const { categoryID, cost, minParticipants, maxParticipants,
            mapURL, leadInstructorId, organizationId, location_id, isPublic, workshopProgram, contact_id } = this.state
        return {
            username: this.props.user,
            groupName: this.state.groupName,
            groupType: this.state.groupType, //"Training Provider"
            groupAddress: this.state.groupAddress,
            groupCity: this.state.groupCity,
            groupState: this.state.groupState,
            groupZipcode: this.state.groupZipcode,
            groupMapURL: this.state.groupMapURL,

            locID: this.state.locID,
            credit: 0,


            // converts empty string to null (empty string is necessary for the textfields to work, but the POST requires null)
            maxParticipants: maxParticipants === '' ? null : maxParticipants,
            minParticipants: minParticipants === '' ? null : minParticipants,
            lang: this.state.lang.value,
            cost: cost === '' ? null : cost,

            location_id: location_id ? location_id.value : null,
            mapURL,
            isPublic,
            categoryID: categoryID ? categoryID.value : null,
            contact_id: contact_id ? contact_id.value : null,
            workshopProgram: workshopProgram ? workshopProgram.value : null,
            leadInstructorId: leadInstructorId ? leadInstructorId.value : null,
            organizationId: organizationId ? organizationId.value : null,

        }
    }

    onAdd = async () => {

        const data = this.getDataFromStateFields()
        try {
            await createTrainingProvider(data)
            sessionStorage.setItem("selectedTP", this.state.groupName )
            this.props.goBack()

        } catch (err) {
            this.props.setError(err)
        }

    }

    onUpdate = async () => {
        const data = this.getDataFromStateFields()
        try {
            await updateTrainingProvider(this.props.ID, data, this.props.token)
            if (this.props.admin) {
                let selected = JSON.parse(sessionStorage.getItem('adminSelectedTP'));
                if (selected) {
                    selected = {id:selected.id, name: this.state.groupName}
                    sessionStorage.setItem('adminSelectedTP', JSON.stringify(selected))

                }
            } else {
                let selected = JSON.parse(sessionStorage.getItem('selectedTP'));
                if (selected) {
                    selected = {id:selected.id, name: this.state.groupName}
                    sessionStorage.setItem('selectedTP', JSON.stringify(selected))
                }
            }

            this.props.goBack()

        } catch (err) {
            this.props.setError(err)
        }
    }

    handleChange = event => {
        let { name, value } = event.target

        if(name==="cost" && value!==''){
            value=parseFloat((1.0*value).toFixed(2))
            if(value>25 && !(this.context.roles.isClassroomTrainingAdmin === 1 || this.context.roles.isProgramCoordinator === 1)) 
                value=25 // if the cost is over 25 and not an admin then set it to 25
            if(value<0) value=0
        }

        if((name==="minParticipants" || name==="maxParticipants") && value!==''){
            value=Math.trunc(value) // prevent decimal participants
            if(value<0) value=0

        }

        this.setState({ [name]: value });

        // if the category is changing, update the filtered orgs with the correct category ID
        if (name === "categoryID") {
            this.onCategoryChange(value)
        }

    }

    // onProgramChange = async value => {
    //     const mp = await getModulePresentersForProgram(value, this.state.modulePresenters)
    //     this.setState({modulePresenters : mp})
    // }

    handleSelectChange = (name, value) => {
        this.setState({ [name]: value });
    }

    handleOptionChange = event => {
        if (event.target.value === 'isPublic') {
            this.setState({ [event.target.name]: true });
        } else {
            this.setState({ [event.target.name]: false });
        }
    }

    setFilteredOrgs = (cat) => {
        let filteredOrgs = []
        if (cat !== null) {
            filteredOrgs = this.state.organizations.filter(org => org.categoryId === cat.value)
        }
        this.setState({ organizationsFiltered: filteredOrgs })
    }

    onCategoryChange = (cat) => {
        this.setFilteredOrgs(cat)

        // clears organization ID (beacuse category changed, old organization no longer valid) (catvalue is string, org cat id is int)
        this.setState({ organizationId: null })
    }

    onTextChange = event => {
        let { name, value } = event.target

        if(name==="cost" && value!=='') value=parseFloat(parseFloat(value).toFixed(2)) // for some reason toFixed was not seeing value as number
        this.setState({
            [name]: value
        });
    }

    onProgramChange = (event, value) => {
        let selected = value;

        // if program is null, do nothing
        if (selected === null) {
            return
        }

        // get the module presenters that go with the program ID
        axios.get('/api/program/' + selected.value, {
        }).then((res) => {
            let index = -1;
            let mp = res.data.modules.map((u) => {
                index = this.state.modulePresenters.findIndex(e => e.moduleId === u.ID); // grabs current module presenter state

                // if the current module presenter exists in the modulePresenters state (index!= -1) and the module presenter is valid (exists in the instructor list)
                if (index > -1 && this.state.instructors.findIndex(e => e.value === this.state.modulePresenters[index].instructorId) !== -1)
                    return {
                        moduleId: u.ID,
                        moduleName: u.moduleName,
                        instructorName: this.state.modulePresenters[index].instructorName,
                        instructorId: this.state.modulePresenters[index].instructorId
                    };
                else
                    return {
                        moduleId: u.ID,
                        moduleName: u.moduleName,
                        instructorName: null,
                        instructorId: null
                    };
            });

            this.setState({
                modulePresenters: mp,
                //program: JSON.parse(JSON.stringify(selected)),
            });
        }).catch(error => {
            console.log("error:" + error);
            // this.setState({  // there is no error state
            //     error: error.message
            // });
        });
    }

    onStateChange = (event) => {
        let {value} = event.target;
        const selected = value
        
        if (selected === null) {
            this.setState({
                locationStateCode: null,
                locationCounty: null,
                counties: []
            })
            return;
        }

        let selectedState = selected.value;
        axios('/api/stateCounty/county/' + selectedState, {
            method: 'GET'
        })
            .then(res => res.data)
            .then(result => {
                let county = [];
                result.map((u) =>
                    county.push({ label: u.stateCountyName, value: u.stateCountyName })
                );
                this.setState({
                    locationStateCode:  JSON.parse(JSON.stringify(selected)),
                    counties: county
                })
            }).catch(error => {
                console.log("error:" + error);
                this.setState({
                    error: error.message
                });
            });

       // this.setState({ locationState: JSON.parse(JSON.stringify(selected)) });
    }

    // autocomplete changes
    onAutoChange = event => {
        const { name, value } = event.target

        // if there is only one program in the list, and you try to clear the program do nothing
        if (name === "program" && value === null && this.state.programs.length === 1) {
            return
        }

        this.setState({
            [name]: value
        });

        // if the category is changing, update the filtered orgs with the correct category ID
        if (name === "category") {
            this.onCategoryChange(value)
        }


        // if the program changes, update module presenters with the module presenters from the program
        else if (name === "program") {
            this.onProgramChange(null, value) // not updated to async yet
        }

        else if (name === "locTemplate") {
            this.onLocTemplateChange(null, value) // not updated to async yet
        }

        else if (name === "contactTemplate") {
            this.onContactTemplateChange(null, value) // not updated to async yet
        }

    }

    onCheckUsername  = (event) => {
        if (this.state.groupName === undefined || this.state.groupName.length <1) {
            this.setState({ 
                error: "Group Name cannot be empty",
                groupNameChecked : false
            });
            return;
        }

        axios('/api/userGroup/exist/' + this.state.groupType + '/' +this.state.groupName, {
            method: 'GET'
        })
        .then(res => res.data)
        .then(result => {
            if (result.exist) {
                // username is already been used, set error message
                this.setState({ 
                    groupNameChecked : false,
                    error: this.state.groupName + " has already been used. Please pick a different Group Name."
                });
            }
            else {
                this.setState({ groupNameChecked: true});
            }
                
        }).catch(error => {
            this.setError(error);
        });
    }

    render() {
        const classes = this.props.classes
        //return (
        return this.state.loading ? <Loading /> : (
            <ValidatorForm
                noValidate
                onSubmit={this.props.ID === undefined ? this.onAdd : this.onUpdate}
            >
                <Fragment>
                    <PageHeader
                        title={"Training Provider"}
                        cancel={this.props.goBack}
                        actionButtons={[{ label: this.props.ID === undefined ? "Add" : "Update", disabled: !this.state.groupNameChecked &&  this.props.ID === undefined }]}
                        errorDetails={{
                            feedback: this.state.error,
                            dismiss: this.hideError
                        }}
                    />

                    <Grid container spacing={3}>

                        {
                            this.props.ID === undefined
                            ?
                            <>
                                <Grid item xs={12} sm={6} >
                                    <TextValidator
                                        id="groupName"
                                        label="Unique Name for this Training Provider"
                                        type="text"
                                        className={[classes.textField].join(' ')}
                                        onChange={this.handleChange}
                                        value={this.state.groupName}
                                        name='groupName'
                                        InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                {this.state.groupNameChecked ? <CheckIcon /> : "" }
                                                </InputAdornment>
                                                )
                                        }}
                                        validators={['required']}
                                        errorMessages={['Name is required']}
                                        fullWidth
                                        required
                            />
                            </Grid>

                            <Grid item xs={2}>
                                <Box display="flex" mt={2.5}>
                                    <Button variant="outlined"  onClick={this.onCheckUsername} size="small" color="primary" className={[].join(' ')} > { 'Check' } </Button>
                                </Box>
                            </Grid>
                            </>
                            :
                            <>
                                <Grid item xs={12} sm={5} >
                                    <TextField
                                        id="groupName"
                                        label="Name of this Training Provider"
                                        type="text"
                                        className={[classes.textField].join(' ')}
                                        onChange={this.handleChange}
                                        value={this.state.groupName}
                                        name='groupName'
                                        InputProps={{
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                {this.state.groupNameChecked ? <CheckIcon /> : "" }
                                                </InputAdornment>
                                                )
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                  <Grid item xs={1}>
                                <Box display="flex" mt={2.5}>
                                    <Button variant="outlined"  onClick={this.onCheckUsername} size="small" color="primary" className={[].join(' ')} > { 'Check' } </Button>
                                </Box>
                            </Grid>
                            </>
                        }
                        

                        <GridTextValidator
                            xs={12}
                            sm={6}
                            label="Organization Address"
                            type="text"
                            name="groupAddress"
                            value={this.state.groupAddress}
                            onChange={this.handleChange}
                            classes={classes}
                            validators={['required']}
                            errorMessages={['Address is required']}
                        />

                        

                        {/* <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="standard-basic"
                                label="Employer Address"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.groupAddress}
                                name='groupAddress'
                                validators={['required']}
                                errorMessages={['Address is required']}
                                fullWidth
                                required
                            />
                        </Grid> */}
                        <GridTextValidator
                            xs={12}
                            sm={6}
                            label="City"
                            type="text"
                            name="groupCity"
                            value={this.state.groupCity}
                            onChange={this.handleChange}
                            classes={classes}
                            validators={['required']}
                            errorMessages={['City is required']}
                        />
                        {/* <Grid item xs={12} sm={6}>
                            <TextValidator
                                id="standard-basic"
                                label="City"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.groupCity}
                                name='groupCity'
                                validators={['required']}
                                errorMessages={['City is required']}
                                fullWidth
                                required
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={3}>
                            <SelectValidator
                                id="groupState"
                                name="groupState"
                                style={{ minWidth: '5ch' }}
                                className={[classes.textField].join(' ')}
                                value={this.state.groupState}
                                onChange={this.handleChange}
                                select
                                validators={['required']}
                                errorMessages={['State is required']}
                                required
                                fullWidth
                                label="State"
                            >
                                {this.state.groupStates.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                        <GridTextValidator
                            xs={12}
                            sm={3}
                            label="Zipcode"
                            type="text"
                            name="groupZipcode"
                            value={this.state.groupZipcode}
                            onChange={this.handleChange}
                            classes={classes}
                            validators={['required']}
                            errorMessages={['Zipcode is required']}
                        />
                     
                    </Grid>

                    <PageHeader
                        title={"Default Class Settings"}
                    />



                    {/* <Collapse in={this.state.formVisible}> */}
                    <Grid container spacing={3}>
                        <GridAutoTextField
                            xs={12}
                            sm={6}
                            lg={4}
                            name="categoryID"
                            options={this.state.categories}
                            value={this.state.categoryID}
                            //handleSelectChange={this.handleSelectChange}
                            onChange={this.handleChange}
                            classes={classes}
                            label="Category"
                        />

                        <Grid item xs={12} sm={6} lg={4}>

                        <GridAutoTextValidator
                            name="lang"
                            options={languages}
                            value={this.state.lang}
                            onChange={this.onAutoChange}
                            classes={classes}
                            validators={['required']}
                            errorMessages={['Language is required']}
                            required
                            label="Language"
                        />

                        </Grid>

                        <Grid item xs={12} sm={6} lg={4}>
                            <TextValidator
                                id="cost"
                                name="cost"
                                label="Training Cost (limit $30 in-person, $10 remote)"
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.cost}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} lg={4}>
                            <TextField
                                id="maxParticipants"
                                name="maxParticipants"
                                label="Max Participants"
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.maxParticipants}
                                fullWidth
                            />
                        </Grid>

                        <GridAutoTextValidator
                            xs={12}
                            sm={6}
                            lg={4}
                            name="leadInstructorId"
                            options={this.state.leadInstructors}
                            value={this.state.leadInstructorId}
                            //handleSelectChange={this.handleSelectChange}
                            onChange={this.handleChange}
                            classes={classes}
                            label="Lead Instructor"
                        />
                        {/* <Grid item xs={12} md={6} lg={4}>
                                <Autocomplete
                                    id="leadInstructorId"
                                    options={this.state.leadInstructors}
                                    getOptionLabel={(option) => option.label}
                                    value={this.state.leadInstructorId}
                                    onChange={(event, value) => { this.handleSelectChange("leadInstructorId", value) }}
                                    className={[classes.autoComplete].join(' ')}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Lead Instructor"
                                            className={[classes.textField].join(' ')}
                                            fullWidth
                                        />)}
                                />
                            </Grid> */}

                        <GridAutoTextField
                            xs={12}
                            sm={6}
                            lg={4}
                            name="organizationId"
                            options={this.state.organizationsFiltered}
                            value={this.state.organizationId}
                            disabled={this.state.categoryID === null}
                            //handleSelectChange={this.handleSelectChange}
                            onChange={this.handleChange}
                            classes={classes}
                            label="Organization"
                        />

                        <GridAutoTextField
                            xs={12}
                            sm={12}
                            name="workshopProgram"
                            options={this.state.programs}
                            value={this.state.workshopProgram}
                            //handleSelectChange={this.handleSelectChange}
                            onChange={this.handleChange}
                            classes={classes}
                            label="Training Program"
                        />
                     
                        <Grid item xs={12}>
                            <br />
                            <FormLabel component="legend">Public/Private?</FormLabel>
                            <RadioGroup row aria-label="open" name="open" onChange={this.handleOptionChange}>
                                <FormControlLabel
                                    id="isPublic"
                                    value="isPublic"
                                    checked={this.state.isPublic}
                                    control={<Radio color="primary" />}
                                    label="Public"
                                    name="isPublic"
                                />
                                <FormControlLabel
                                    id="isPrivate"
                                    value="isPrivate"
                                    checked={!this.state.isPublic}
                                    control={<Radio color="primary" />}
                                    label="Private"
                                    name="isPublic"
                                />
                            </RadioGroup>
                        </Grid>
                        <LocationBox 
                            locTemplates = {this.state.locTemplates}
                            locTemplate = {this.state.locTemplate}
                            onAutoChange = {this.onAutoChange} 
                            classes = {classes}
                            onAddLocationTemplate = {this.onAddLocationTemplate}
                            onTextChange = {this.onTextChange} 
                            locationName = {this.state.locationName}
                            locationStreet = {this.state.locationStreet}
                            locationCity = {this.state.locationCity}
                            counties = {this.state.counties}      
                            locationCounty = {this.state.locationCounty}
                            locationStateCode = {this.state.locationStateCode}
                            states = {this.state.states}
                            onStateChange = {this.onStateChange} 
                            locationZipcode = {this.state.locationZipcode}
                            locationMapURL = {this.state.locationMapURL}
                            />

                        <ContactBox 
                            contactTemplates = {this.state.contactTemplates}
                            contactTemplate = {this.state.contactTemplate}
                            onAutoChange = {this.onAutoChange} 
                            classes = {classes}
                            onAddContactTemplate = {this.onAddContactTemplate}
                            onTextChange = {this.onTextChange}
                            contactFirstname = {this.state.contactFirstname}
                            contactLastname = {this.state.contactLastname}
                            contactPhone = {this.state.contactPhone}
                            contactEmail = {this.state.contactEmail}
                        />
                      
                    </Grid>

                    {/* </Collapse> */}

                </Fragment>
            </ValidatorForm>
        );
    }
}

export default TrainingProvWorkshop;